(function() {
    'use strict';

    angular
        .module('tmgApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('stat-facturation-mensuel', {
            parent: 'entity',
            url: '/stat-facturation-mensuel',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'tmgApp.statFacturationMensuel.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/stat-facturation-mensuel/stat-facturation-mensuels.html',
                    controller: 'StatFacturationMensuelController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('statFacturationMensuel');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        });
    }

})();
